import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';



@Component({
	selector: 'custom-pagination-controls',
	templateUrl: "./custom-pagination-controls.html",
	styles: [require("./custom-pagination-controls.scss")]
})
export class CustomPaginationControls {
	@Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
	@Input() autoHide: boolean
	@Input() maxSize: number
	@Input() id: string
	@Input() cssClass: string

	public pageChanged(event) {
		this.pageChange.emit(event)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/custom-pagination-controls/custom-pagination-controls.component.ts